import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FiCheckCircle } from 'react-icons/fi'
import { useAuth } from '../contexts/AuthContext'

const BillingSuccess = () => {
  const { refreshEmpleado } = useAuth()

  // Refrescar datos de empresa para que el banner de trial desaparezca
  useEffect(() => {
    refreshEmpleado()
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 via-white to-blue-50 px-4">
      <div className="max-w-md w-full text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6">
          <FiCheckCircle className="h-10 w-10 text-green-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Pago completado</h1>
        <p className="text-gray-600 mb-8">
          Tu suscripcion esta activa. Ya puedes seguir usando PresenzIA sin limites.
        </p>
        <div className="space-y-3">
          <Link
            to="/"
            className="block w-full py-3 px-6 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 transition-colors"
          >
            Ir al panel
          </Link>
          <Link
            to="/configuracion?tab=plan"
            className="block w-full py-3 px-6 border border-gray-300 text-gray-700 font-medium rounded-xl hover:bg-gray-50 transition-colors"
          >
            Ver mi plan
          </Link>
        </div>
      </div>
    </div>
  )
}

export default BillingSuccess
